export default "__VITE_ASSET__CfV2Xqsx__"